import styled from 'styled-components';

import { media } from '@gympass/yoga-helpers';

export const Content = styled.div`
  background-color: ${({ theme }) => theme.yoga.colors.white};
  height: 100%;
  min-height: 100vh;
`;

export const ContentBody = styled.div<{ isFormType: boolean }>`
  display: grid;
  flex-direction: column;
  margin: 0 auto;
  min-height: calc(100vh - 174px);
  padding: 0px;
  position: relative;
  width: ${({ theme, isFormType }) =>
    isFormType ? '100%' : `${theme.yoga.sizes.pageContentWidth}px`};

  ${({ theme }) => media.not.md`
    width: 100%;
    padding: ${theme.yoga.spacing.large}px;
  `}

  iframe {
    width: 100%;
    height: 100%;
    box-shadow: 0px 8px 20px rgb(152 152 166 / 25%);
    border-radius: ${({ theme }) => theme.yoga.radii.small}px;
    border: none;
  }
`;
